import React from 'react'
import PropTypes from 'prop-types'

import TextField from '../../../../FormLegacy/FormFieldsV2/TextField'

import FormInput from './FormInput'

const TextInput = ({
  columnSize,
  name,
  label,
  placeholder,
  leftIcon,
  value,
  helperText,
  setFieldValue,
  maxLength = 100,
}) => {
  return (
    <div className={`column is-${columnSize}`}>
      <FormInput label={label} name={name}>
        <React.Fragment>
          <TextField
            name={name}
            onChange={(e) => setFieldValue(name, e.target.value)}
            value={value}
            leftIcon={leftIcon}
            placeholder={placeholder}
            maxLength={maxLength}
          />
          {helperText && <p className="event-form-input-helper-text">{helperText}</p>}
        </React.Fragment>
      </FormInput>
    </div>
  )
}

TextInput.propTypes = {
  columnSize: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  leftIcon: PropTypes.object,
  value: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default TextInput
